import React from 'react';
import {getDate, getTypes, useStyles} from './helper';
import PhotoSlider from './block/photoslider';
import Success from './block/success';
import Cancel from './block/cancel';

const KycItem = ({item}) => {
    const classes = useStyles();
    const [openModal, setOpenModal] = React.useState('');
    const [accept, setAccept] = React.useState(false);
    const [cancel, setCancel] = React.useState(false);
    const [id, setId] = React.useState(undefined);
    const [descriptionArea, setDescriptionArea] = React.useState('');

    const {id: ids, login, dates, types, photo, description} = item;

    return (
        <div className={classes.root}>
            <span className={classes.date}>{getDate(dates)}</span>
            <span className={classes.type}>{getTypes(types)}</span>
            <div className={classes.wrapLogin}>
                <span>{login}</span>
            </div>
            {
                description !== 'undefined' && <span>Номер карты: {description}</span>
            }
            <div className={classes.wrapImage} onClick={() => setOpenModal(photo)}>
                <img src={photo} alt="placeholder" className={classes.image}/>
            </div>
            <div className={classes.wrapBtn}>
                <span 
                    className={classes.success} 
                    onClick={() => {
                        setAccept(true)
                        setId(ids)
                    }}
                >Подтвердить</span>
                <span 
                    className={classes.cancel}
                    onClick={() => {
                        setCancel(true)
                        setId(ids)
                    }}    
                >Отказать</span>
            </div>
            <PhotoSlider openModal={openModal} setOpenModal={setOpenModal} />
            <Success accept={accept} setAccept={setAccept} id={id}/>
            <Cancel cancel={cancel} setCancel={setCancel} setDescriptionArea={setDescriptionArea} descriptionArea={descriptionArea} id={id}/>
        </div>
    )
}

export default KycItem;